module.exports = __webpack_public_path__ + "static/img/image-0.6e852386.jpg";